import React from 'react'
import type { ReactElement } from 'react'
import { TextField, InputAdornment } from '@mui/material'
import CakeIcon from '@mui/icons-material/Cake'

interface YearInputProps {
  value: number | null | undefined
  onChange: (year: number | undefined) => void
  disabled?: boolean
  label?: string
  minYear?: number
  maxYear?: number
  icon?: ReactElement | null
  onInvalidYear?: (message: string) => void
}

export const YearInput = ({
  value,
  onChange,
  disabled = false,
  label = 'Year',
  minYear = 1900,
  maxYear = new Date().getFullYear(),
  icon = <CakeIcon color="primary" sx={{ mr: 1 }} />,
  onInvalidYear
}: YearInputProps): JSX.Element => {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>): void => {
    const yearInput = e.target.value
    const parsedValue = yearInput === '' ? undefined : Number(yearInput)
    onChange(parsedValue)
  }

  const handleBlur = (): void => {
    if (value !== undefined && value !== null && (value < minYear || value > maxYear)) {
      onChange(undefined)
      if (onInvalidYear !== undefined) {
        onInvalidYear(`Invalid ${label} year. Year must be between ${minYear} and ${maxYear}.`)
      }
    }
  }

  return (
    <TextField
      label={label}
      type="number"
      value={value ?? ''}
      onChange={handleChange}
      onBlur={handleBlur}
      disabled={disabled}
      fullWidth
      InputProps={{
        startAdornment: icon != null
          ? (
            <InputAdornment position="start">
              {React.cloneElement(icon, {
                sx: {
                  mr: 1,
                  color: disabled ? 'text.disabled' : 'primary.main'
                }
              })}
            </InputAdornment>
            )
          : undefined
      }}
    />
  )
}
